module.exports = __webpack_public_path__ + "img/logo1.7b639da1.png";